<div class="attendance-individual-punch-import-container">
  <mat-card>
    <mat-card-header>
      <mat-card-title>
        <mat-icon>upload_file</mat-icon>
        Import Individual Punch Records from NgTeco
      </mat-card-title>
      <mat-card-subtitle>
        Upload a NgTeco individual punch report to import attendance records. The system will match Person ID to employees and determine punch direction automatically.
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <div class="import-section">
        <div class="file-upload-area">
          <input 
            type="file" 
            accept=".xlsx,.csv" 
            (change)="onFileSelected($event)"
            [disabled]="loading"
            #fileInput
          />
          <p class="file-hint">Supported formats: .xlsx, .csv</p>
          <p class="format-info">
            <strong>Expected format:</strong> Person ID, Person Name, Punch Date, Attendance Record, Verify Type, TimeZone, Source
          </p>
        </div>
        
        <div *ngIf="loading" class="loading-section">
          <mat-spinner diameter="40"></mat-spinner>
          <p>Processing file and importing individual punch records...</p>
        </div>
        
        <div *ngIf="importSummary" class="import-summary">
          <mat-icon [class.success]="importSummary.includes('Successfully')" [class.error]="importSummary.includes('failed')">
            {{ importSummary.includes('Successfully') ? 'check_circle' : importSummary.includes('failed') ? 'error' : 'info' }}
          </mat-icon>
          <span>{{ importSummary }}</span>
        </div>

        <div *ngIf="errors.length > 0" class="error-section">
          <mat-icon>error</mat-icon>
          <h4>Import Errors:</h4>
          <ul>
            <li *ngFor="let error of errors">{{ error }}</li>
          </ul>
        </div>
        
        <div *ngIf="importedRecords.length > 0" class="preview-section">
          <h4>Preview of Imported Records ({{ importedRecords.length }} records):</h4>
          <div class="table-container">
            <table mat-table [dataSource]="importedRecords" class="preview-table">
              <ng-container matColumnDef="personId">
                <th mat-header-cell *matHeaderCellDef>Person ID</th>
                <td mat-cell *matCellDef="let record">{{ record.personId }}</td>
              </ng-container>
              
              <ng-container matColumnDef="personName">
                <th mat-header-cell *matHeaderCellDef>Person Name</th>
                <td mat-cell *matCellDef="let record">{{ record.personName }}</td>
              </ng-container>
              
              <ng-container matColumnDef="punchDate">
                <th mat-header-cell *matHeaderCellDef>Punch Date</th>
                <td mat-cell *matCellDef="let record">{{ record.punchDate }}</td>
              </ng-container>
              
              <ng-container matColumnDef="attendanceRecord">
                <th mat-header-cell *matHeaderCellDef>Time</th>
                <td mat-cell *matCellDef="let record">{{ record.attendanceRecord }}</td>
              </ng-container>
              
              <ng-container matColumnDef="source">
                <th mat-header-cell *matHeaderCellDef>Device ID</th>
                <td mat-cell *matCellDef="let record">{{ record.source }}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="['personId', 'personName', 'punchDate', 'attendanceRecord', 'source']"></tr>
              <tr mat-row *matRowDef="let row; columns: ['personId', 'personName', 'punchDate', 'attendanceRecord', 'source'];"></tr>
            </table>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
